import { useState, useEffect, useCallback } from 'react'
import { getCargos, getAreasAfinidad } from '@/common/utils/services/usuarios.service'
import { mapCargosToOptions, mapAreasToOptions } from '../util/mappers'

export const useCargosAreas = () => {
  const [cargoOptions, setCargoOptions] = useState([])
  const [areaOptions, setAreaOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchData = useCallback(async () => {
    setLoading(true)
    setError(null)

    try {
      const [cargosRes, areasRes] = await Promise.all([getCargos(), getAreasAfinidad()])

      if (cargosRes.code === 200) {
        setCargoOptions(mapCargosToOptions(cargosRes.data))
      } else {
        setError('Error al cargar los cargos')
      }

      if (areasRes.code === 200) {
        setAreaOptions(mapAreasToOptions(areasRes.data))
      } else {
        setError('Error al cargar las áreas de afinidad')
      }
    } catch (e) {
      console.error('No se pudieron cargar cargos y áreas de afinidad', e)
      setError('Error de conexión')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    cargoOptions,
    areaOptions,
    loading,
    error,
    refetch: fetchData,
  }
}
